import { Button, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const ApproveBtn = ({
  disabled,
  onClick
}: {
  disabled: boolean
  onClick: () => void
}) => {
  return (
    <Button
      size='large'
      color='secondary'
      startIcon={
        <CheckCircleIcon
          sx={{
            color: !disabled ? '#1AAA71' : 'disabledBackground'
          }}
        />
      }
      onClick={onClick}
      disabled={disabled}
      sx={{
        marginLeft: '20px',
        backgroundColor: !disabled
          ? 'rgba(26, 170, 113, 0.08)'
          : 'disabledBackground',
        minWidth: '114px'
      }}>
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 700,
          color: !disabled ? '#1AAA71' : undefined
        }}>
        Approve
      </Typography>
    </Button>
  )
}

export default ApproveBtn
